import axios from "axios";
import { WEB_URL } from "../../constants";

export const PassResetApi = async (body, ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    try {
        let res = await axios.post(WEB_URL + "reset_password", body);
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }
}